import React, {PropsWithChildren} from 'react';
import classNames from 'classnames';
import FormButton from 'src/components/button';
import {ButtonColors, ButtonSizes} from 'shared/constants';
import GoogleLogo from 'shared/img/google-logo.svg';
import 'stylesheets/components/shared-google-button.scss';

interface Props extends PropsWithChildren {
  size?: ButtonSizes;
  color?: ButtonColors;
  className?: string;
  buttonName?: string;
  onClick?: () => void;
}

const GoogleButton = ({
  size = 'medium',
  color = 'gray',
  className = '',
  buttonName,
  children,
  ...props
}: Props) => (
  <FormButton
    {...props}
    buttonName={buttonName}
    color={color}
    outline
    className={classNames('shared-google-button', className)}
  >
    <GoogleLogo className={`shared-google-button-logo-${size}`} />
    {children}
  </FormButton>
);

export default GoogleButton;
